export const initialPopupKeys = {
  features: () => ['newFeatures'],
  termsAndConditions: () => ['termsAndConditions'],
};
